import { fromKey } from '@tmap/mmm-core/entityKey';
import makeThunktankAction from '@tmap/mmm-core/redux/thunktank/makeThunktankAction';
import client from '../client';
import { getClient } from '../lib/apiClient';
import {
  RECEIVE_COMMUNITIES,
} from '../reducers/community';

export const getCommentToken = makeThunktankAction(async (communityId) => (
  (await getClient(process.env.NEXT_PUBLIC_API_DOMAIN).get(`/api/v1/communities/${communityId}/comment-token`)).data
));

export function getCommunities(communityKeys) {
  return async (dispatch) => {
    const qs = communityKeys.map((i) => `"${fromKey(i).id}"`).join(',');
    const communities = await client.fetch(`
      *[_type == "community" && _id in [${qs}]]{
        ...,
        "offers": *[ _type == "incentive" && status != "inactive" && listingBehavior != "unlisted" && ^._id in communities[]._ref ],
      } | order(count(offers) desc, locationText)
    `);
    dispatch({
      type: RECEIVE_COMMUNITIES,
      communities,
    });
  };
}

export const searchCommunitiesByName = makeThunktankAction(
  async (search) => {
    const tokenizedSearch = search.trim().split(/[\s,]+/).map((str) => `"*${str}*"`);
    const communities = await client.fetch(`
      *[_type == "community" && (
        ${tokenizedSearch.map((str) => `[locationText, regionText] match ${str}`).join(' && ')}
      )]
    `);
    return communities;
  },
);
